import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import ConnectButton from './ConnectButton';
import Wrapper from './Wrapper';
import useDialogLauncher from '../../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../../dialogs_new/DialogManager';

EventBanner.propTypes = {
  user: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired
};

export default function EventBanner(props) {
  const {
    user,
    event
  } = props;

  const launch = useDialogLauncher();

  const creator = useConnect('user.byId', {
    id: event.data.creatorId
  });

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          eventId: event.id
        }
      }
    },
    include: function(model) {
      return (
        model.data.userId === user.id &&
        model.data.eventId === event.id
      );
    }
  });

  function showInviteDialog() {
    launch(DialogManager.InvitationInvite.Config(event.id, user.id));
  }

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <Wrapper user={user} creator={creator} type="event">
        <ConnectButton disabled={true}>
          ...
        </ConnectButton>
      </Wrapper>
    );
  }

  // if (user.id === currentUser.id) {
  //   return (
  //     <Wrapper user={user} creator={creator}>
  //       <ConnectButton disabled={true}>
  //         This is you
  //       </ConnectButton>
  //     </Wrapper>
  //   );
  // }

  if (invitations.data.length > 0) {
    return (
      <Wrapper user={user} creator={creator} type="event">
        <ConnectButton disabled={true}>
          Connected
        </ConnectButton>
      </Wrapper>
    );
  }

  return (
    <Wrapper user={user} creator={creator} type="event">
      <ConnectButton onClick={showInviteDialog}>
        Connect
      </ConnectButton>
    </Wrapper>
  );
};
